import { render, staticRenderFns } from "./Gei.vue?vue&type=template&id=7ac8e09a&"
import script from "./Gei.vue?vue&type=script&lang=js&"
export * from "./Gei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports